<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="6" xl="6">
                <transition name="slide">
                    <b-card v-if="settings">
                        <b-form-group :label="this.$t('playSound')" :label-cols="12" :horizontal="false">
                            <c-switch color="success" v-model="settings.play_sound" />
                        </b-form-group>

                        <b-form-group :label="this.$t('notifications')" :label-cols="12" :horizontal="false">
                            <b-button @click="subscribe" variant="primary" v-if="!notificationPermission"> {{
                                $t('subscribe') }} </b-button>
                            <b-alert :show="notificationPermission" variant="success"> {{ $t('subscribed') }} </b-alert>
                        </b-form-group>

                        <b-card-footer>
                            <b-button @click="save" variant="success">{{ $t('save') }}</b-button>
                        </b-card-footer>
                    </b-card>
                </transition>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue'
import { getNotificationsToken } from '../../firebase'

export default {
    name: "Settings",
    components: {
        cSwitch
    },
    data: function () {
        return {
            settings: null
        }
    },

    computed: {
        notificationPermission() {
            return Notification.permission == "granted"
        }
    },

    methods: {
        save() {
            this.$store.dispatch("updateUserConfig", { path: "notification_settings", data: this.settings }).then(resp => {

                this.$bvToast.toast("Notification settings updated", {
                    variant: 'success',
                    title: "Success"
                })
            })
        },

        async subscribe() {
            let token = await getNotificationsToken()

            this.$http.post("/v1/project/notifications/subscribe", { token: token }).then(resp => {
                console.log(resp)
            }).catch(err => {
                this.$bvModal.msgBoxOk(t("failedToSubscribe"))
            })
        }
    },

    mounted() {
        this.$store.dispatch("fetchUserConfigs").then((data) => {
            let settings = this.$store.getters.userConfig("notification_settings");

            this.settings = settings.data || {
                play_sound: false
            }
        });

        console.log()
    }
}
</script>
